import React from "react";
import routes from ".front-commerce/routes.js";
import renderRoutes from "./core/router/renderRoutes";
import { RoutesProvider } from "theme/modules/Router/RoutesContext";

const routesElement = renderRoutes(routes);

export default () => {
  return <RoutesProvider routes={routes}>{routesElement}</RoutesProvider>;
};
